import { withTranslation } from 'react-i18next'

import ReviewsSurveyAccessibleReviewerTypeSection from './ReviewsSurveyAccessibleReviewerTypeSection'

export default withTranslation('admin')(ReviewsSurveyAccessibleReviewerTypeSection)
